import React, {useState} from 'react';
import {useDarkMode} from "../../contexts/darkModeContext";
import {Button, Input} from "@headlessui/react";
import {TrashIcon, UserPlusIcon, XCircleIcon} from "@heroicons/react/24/outline";
import {Droppable} from "react-beautiful-dnd";

const Task = ({ index, onRemove, task, employees, setEmployees, setTasks }) => {
    const { darkMode } = useDarkMode();

    const handleRemoveEmployee = (emp) => {
        // Remove the employee from the task
        const updatedTask = { ...task, employees: task.employees.filter(e => e.id !== emp.id) };

        // Add the employee back to the global employees list
        setTasks((prevTasks) =>
            prevTasks.map((t) => (t.id === task.id ? updatedTask : t))
        );
        setEmployees((prevEmployees) => [...prevEmployees, emp]);
    };


    return (
        <div className={`flex flex-col border-2 ${darkMode ? 'bg-bgcard/20 border-neutral-700 text-white shadow-xl' : 'bg-white text-black shadow-md'} rounded-lg h-64`}>
            {/* Header */}
            <div
                className={`flex h-12 py-2 pl-2 items-center border-b-2 ${
                    darkMode ? 'border-neutral-700' : ''
                } w-full`}
            >
                <Input
                    id="title"
                    name="title"
                    type="text"
                    placeholder="Enter task or job title..."
                    className={`${
                        darkMode
                            ? 'bg-bgDark outline-neutral-700'
                            : 'bg-white outline-gray-300'
                    } block w-full rounded-md px-3 py-1 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                />

                <Button onClick={onRemove} className={`mx-3`}>
                    <TrashIcon className={`size-4 text-red-600 hover:text-opacity-50`}/>
                </Button>
            </div>

            <div className={`h-52 overflow-y-scroll scrollbar-none`}>
                {/* Droppable Area */}
                <Droppable droppableId={`task-${task.id}`}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`flex-1 h-full p-2 rounded-b-lg transition-all ${snapshot.isDraggingOver ? "bg-green-600/25" : ""}`}
                        >
                            {task.employees.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-full text-gray-400">
                                    <UserPlusIcon className="size-8" />
                                    <span className="mt-2 text-sm font-semibold">No Team Members</span>
                                </div>
                            ) : (
                                task.employees.map((emp, index) => (
                                    <div
                                        key={emp.id}
                                        className={`p-2 border-2 ${darkMode ? 'border-neutral-700' : ''} rounded mb-1 text-sm flex justify-between items-center`}
                                    >
                                        {emp.name}
                                        <Button
                                            onClick={() => handleRemoveEmployee(emp)}
                                            className="ml-2 text-red-500 hover:text-red-700"
                                        >
                                            <XCircleIcon className={`size-5 hover:animate-heartbeat`}/>
                                        </Button>
                                    </div>
                                ))
                            )}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>


        </div>


    );
};

export default Task;
